import React from 'react';

import PropTypes from 'prop-types';
import { Spinner } from '@telus-uds/components-web';

import { Backdrop, ModalMain, ModalInner, ModalMessageMain } from './css';

const WlsLoader = ({ message }) => {
  return (
    <Backdrop>
      <ModalMain>
        <ModalInner>
          <ModalMessageMain>
            <Spinner show label={message} />
          </ModalMessageMain>
        </ModalInner>
      </ModalMain>
    </Backdrop>
  );
};

WlsLoader.propTypes = {
  message: PropTypes.string.isRequired
};

export default WlsLoader;
